import styled from "styled-components";

export const LegendActionsRoot = styled.div`
  flex: 0 0 auto;
  position: relative;
  margin-left: auto;
`;
